import React from 'react';
import { setGlobalLoader } from 'store/actions/global-loader.actions';

import { ChipsItem } from './ChipsItem';

type ChipsItemProps = {
  title: string;
  clickableLink: any;
  isClickable: boolean;
};

const ChipsItemContainer = (props: ChipsItemProps) => {
  const onClick = (e) => setGlobalLoader(true, e);

  return <ChipsItem {...props} onClick={onClick} />;
};

export default ChipsItemContainer;
